import { render, staticRenderFns } from "./Shifts.vue?vue&type=template&id=72a607c8&"
import script from "./Shifts.vue?vue&type=script&lang=ts&"
export * from "./Shifts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports